import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  getProjectByIdService,
  getProjectName,
  projectInviteFilterService,
} from "../../../../Services/projectService";
import { getApprovalFormByProjectId } from "../../../../Services/approvalFormService";
import { getSafeJobAnalysisByProjectId } from "../../../../Services/safeJobAnalysisService";
import { getObservationById } from "../../../../Services/observationService";
import { materialListWithProjectGetService } from "../../../../Services/materialListWithProjectService";
import { getSubscriptionData } from "../../../../Services/subscriptionService";
import { SetProjectAccessLevel } from "../../../../Redux/Slice/projectSlice";
import { Link } from "react-router-dom";
import { FaArrowUp, FaArrowDown } from "react-icons/fa";

import Loader from "../../../../components/loader";
import MainLayout from "../../../components/layout/MainLayout";

const ProjectView = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("overview");
  const [backgroundImage, setBackgroundImage] = useState("");
  const { projectId } = useParams();
  const { loggedInUser } = useSelector((state) => state.auth);
  const [projectDetails, setProjectDetails] = useState();
  const [loading, setLoading] = useState(false);
  const { accessLevel: type } = useSelector((state) => state?.project);
  const [scaffoldStatus, setScaffoldStatus] = useState("inactive");
  const [eventsData, setEventsData] = useState([]);
  const [materialData, setMaterialData] = useState([]);
  const [scaffoldSize, setScaffoldSize] = useState([]);
  const [m2, setM2] = useState(0);
  const [m3, setM3] = useState(0);
  const [lm, setLm] = useState(0);
  const [hm, setHm] = useState(0);
  const [scaffoldingCount, setScaffoldingCount] = useState(0);
  const [sja, setSja] = useState(0);
  const [observationCount, setObservationCount] = useState(0);
  const [materialWeight, setMaterialWeight] = useState(0);
  const [scaffoldingItems, setScaffoldingItems] = useState(0);
  const [sjaIsLoading, setSjaIsLoading] = useState(false);
  const [onservationIsLoading, setObservationIsLoading] = useState(false);
  const [scaffoldingWeightLoading, setScafoldingWeightCountLoading] =
    useState(false);
  const customerId = useSelector((state) => state?.auth?.loggedInUser?._id);
  const [userSubscriberData, setUserSubscriberData] = useState([]);
  const [projectUserId, setProjectUserId] = useState(null);
  const [filterProject, setFilterProject] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    getProjectDetailById(projectId);
    getApprovalFormByItsProjectId(projectId);
    getSaveJobAnalysis(projectId);
    getObservation(projectId);
    getMaterialListWithProjectWeight(projectId);
    getSubscriptionDataAndCount();
    fetchProjectName();
    inviteProjectFilter();
  }, []);

  useEffect(() => {
    calculateSums();
  }, [scaffoldSize]);

  useEffect(() => {
    calculateScaffoldingWeightAndItems(materialData);
  }, [materialData]);

  const calculateSums = () => {
    const scaffoldingCounts = 0;
    const totals = {
      m2: 0,
      m3: 0,
      lm: 0,
      hm: 0,
    };

    scaffoldSize
      ?.filter((scaffold) => scaffold.status === "active")
      ?.forEach((scaffoldGroup) => {
        scaffoldGroup?.scaffoldName?.forEach((scaffold) => {
          if (scaffold?.measurements?.m2?.length) {
            scaffold?.measurements?.m2?.forEach((measurement) => {
              const { length, width } = measurement;
              totals.m2 += Number.parseFloat(length) * Number.parseFloat(width);
            });
          }
          if (scaffold?.measurements?.m3?.length) {
            scaffold?.measurements?.m3?.forEach((measurement) => {
              const { length, width, height } = measurement;
              totals.m3 +=
                Number.parseFloat(length) *
                Number.parseFloat(width) *
                Number.parseFloat(height);
            });
          }
          if (scaffold?.measurements?.lm?.length) {
            scaffold?.measurements?.lm?.forEach((measurement) => {
              const { length } = measurement;
              totals.lm += Number.parseFloat(length);
            });
          }
          if (scaffold?.measurements?.hm?.length) {
            scaffold?.measurements?.hm?.forEach((measurement) => {
              const { height } = measurement;
              totals.hm += Number.parseFloat(height);
            });
          }
        });
      });
    setM2(totals?.m2);
    setM3(totals?.m3);
    setLm(totals?.lm);
    setHm(totals?.hm);
    setScaffoldingCount(scaffoldingCounts);
  };

  const calculateScaffoldingWeightAndItems = (item) => {
    let scaffoldingSum = 0;
    let materialActiveItems = 0;
    item.forEach((ele) => {
      const { isDeleted } = ele;
      if (!isDeleted) {
        materialActiveItems += Number.parseInt(ele?.materialList?.length, 10);
      }
    });

    item.forEach((ele) => {
      const { totalWeight, isDeleted } = ele;
      if (!isDeleted) {
        scaffoldingSum += Number.parseInt(totalWeight, 10);
      }
    });
    setScaffoldingItems(materialActiveItems);
  };

  const getApprovalFormByItsProjectId = async () => {
    try {
      const response = await getApprovalFormByProjectId(projectId);
      setScaffoldSize(response?.data?.data || []);
    } catch (error) {
      return error;
    }
  };

  const getSaveJobAnalysis = async () => {
    let sjaCount = 0;
    try {
      setSjaIsLoading(true);
      const checkProjectStatus = await getProjectByIdService(projectId);
      const projectStatus = checkProjectStatus?.data?.project?.status;
      if (projectStatus === "active") {
        const response = await getSafeJobAnalysisByProjectId(projectId);
        const sjaData = response?.data;

        sjaData?.forEach((ele) => {
          const { isDeleted } = ele;
          if (!isDeleted) {
            sjaCount++;
          }
        });
        setSja(sjaCount);
      }
    } catch (error) {
      return error;
    } finally {
      setSjaIsLoading(false);
    }
  };

  const getObservation = async (projectId) => {
    let observationCount = 0;
    try {
      setObservationIsLoading(true);
      const checkProjectStatus = await getProjectByIdService(projectId);
      const projectStatus = checkProjectStatus?.data?.project?.status;
      if (projectStatus === "active") {
        const response = await getObservationById(projectId);
        const observationData = response?.data;

        observationData?.forEach((ele) => {
          const { isDeleted } = ele;
          if (!isDeleted) {
            observationCount++;
          }
        });
        setObservationCount(observationCount);
      }
    } catch (error) {
      setObservationIsLoading(false);
      return error;
    } finally {
      setObservationIsLoading(false);
    }
  };

  function calculateTotalWeight(data) {
    return data
      .filter((item) => item.status === "latest")
      .reduce((totalWeight, item) => {
        const materialWeight = item.materialList?.reduce((sum, material) => {
          return sum + material.kg * material.quantity;
        }, 0);
        return (totalWeight + materialWeight).toFixed(2);
      }, 0);
  }

  const getMaterialListWithProjectWeight = async () => {
    try {
      setScafoldingWeightCountLoading(true);
      const checkProjectStatus = await getProjectByIdService(projectId);

      const projectStatus = checkProjectStatus?.data?.project?.status;
      if (projectStatus === "active") {
        const response = await materialListWithProjectGetService(projectId);
        const materialData = response?.data?.filter(
          (ele) => !ele?.isDeleted && ele?.status === "latest"
        );
        setMaterialData(materialData);
        setIndicator(checkProjectStatus?.data?.project?.transferWeight);
        setMaterialWeight(calculateTotalWeight(materialData));
      }
    } catch (error) {
      setScafoldingWeightCountLoading(false);
      return error;
    } finally {
      setScafoldingWeightCountLoading(false);
    }
  };

  async function getProjectDetailById(id) {
    try {
      setLoading(true);
      const response = await getProjectByIdService(id);
      const projectData = response?.data?.project;
      dispatch(SetProjectAccessLevel(projectData?.accessLevel));
      setProjectUserId(projectData?.userId);
      setScaffoldStatus(projectData?.status);
      setProjectDetails(projectData);
      setBackgroundImage(projectData?.projectBackgroundImage);
      setEventsData(response?.data?.project?.Calendar || []);
    } catch (error) {
      setLoading(false);
      return error;
    } finally {
      setLoading(false);
    }
  }

  async function getSubscriptionDataAndCount() {
    const dataResponse = await getSubscriptionData(customerId);
    const userDataResponse = dataResponse?.data;
    const filterUserDataResponse = userDataResponse?.filter(
      (item) => !item?.isDeleted && item?.isInvitedUser
    );
    setUserSubscriberData(filterUserDataResponse);
  }

  const inviteProjectFilter = async () => {
    const response = await projectInviteFilterService(projectId);
    if (response?.data) {
      setFilterProject(response.data);
    }
  };

  const fetchProjectName = async () => {
    const res = await getProjectName(projectId);
  };

  const activeScaffolds = scaffoldSize.filter(
    (item) => item.status === "active" && !item?.isDeleted
  );

  const getStatusColor = (status) => {
    switch (status) {
      case "active":
        return "bg-green-500";
      case "inactive":
        return "bg-red-500";
      case "completed":
        return "bg-orange-500";
      default:
        return "bg-gray-500";
    }
  };

  const [indicator, setIndicator] = useState(0);

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <MainLayout title={"Project Details"}>
      {loading ? (
        <div className="flex justify-center items-center min-h-[400px]">
          <Loader />
        </div>
      ) : (
        <div className="bg-gray-50 min-h-screen pb-12">
          <div className="container mx-auto px-4 py-8">
            <div className="bg-white rounded-lg shadow-md p-6 mb-6">
              <div className="flex justify-between items-center mb-4">
                <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
                  <div>
                    <h1 className="text-2xl font-bold text-gray-800">
                      {projectDetails?.projectName || "Project Name"}
                    </h1>
                    <div className="flex items-center gap-3 mt-2">
                      <span className="text-sm font-medium text-gray-500">
                        Project #{projectDetails?.projectNumber || "N/A"}
                      </span>
                      <span
                        className={`px-3 py-1 text-xs font-medium text-white rounded-full ${getStatusColor(
                          projectDetails?.status
                        )}`}
                      >
                        {projectDetails?.status || "Status"}
                      </span>
                    </div>
                  </div>
                  {backgroundImage && (
                    <div className="w-24 h-24 rounded-md overflow-hidden">
                      <img
                        src={backgroundImage || "/placeholder.svg"}
                        alt="Project"
                        className="w-full h-full object-cover"
                      />
                    </div>
                  )}
                </div>
                <button
                  className="button-text bg-[#0072BB] px-[20px] py-[10px] rounded-[5px]  text-white"
                  onClick={(e) => handleGoBack(e)}
                >
                  Back
                </button>
              </div>

              {/* Tabs */}
              <div className="border-b border-gray-200">
                <nav className="flex -mb-px space-x-8">
                  <button
                    onClick={() => setActiveTab("overview")}
                    className={`py-4 px-1 border-b-2 font-medium text-sm ${
                      activeTab === "overview"
                        ? "border-blue-500 text-blue-600"
                        : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                    }`}
                  >
                    Overview
                  </button>
                  <button
                    onClick={() => setActiveTab("company")}
                    className={`py-4 px-1 border-b-2 font-medium text-sm ${
                      activeTab === "company"
                        ? "border-blue-500 text-blue-600"
                        : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                    }`}
                  >
                    Company Details
                  </button>
                  <button
                    onClick={() => setActiveTab("project")}
                    className={`py-4 px-1 border-b-2 font-medium text-sm ${
                      activeTab === "project"
                        ? "border-blue-500 text-blue-600"
                        : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                    }`}
                  >
                    Project Details
                  </button>
                  <button
                    onClick={() => setActiveTab("metrics")}
                    className={`py-4 px-1 border-b-2 font-medium text-sm ${
                      activeTab === "metrics"
                        ? "border-blue-500 text-blue-600"
                        : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                    }`}
                  >
                    Metrics
                  </button>
                </nav>
              </div>
            </div>

            {activeTab === "overview" && (
              <div className="space-y-6">
                {/* Project Summary */}
                <div className="bg-white rounded-lg shadow-md p-6">
                  <h2 className="text-lg font-semibold text-gray-800 mb-4">
                    Project Summary
                  </h2>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <div className="mb-4">
                        <p className="text-sm font-medium text-gray-500">
                          Project Name
                        </p>
                        <p className="text-gray-800">
                          {projectDetails?.projectName || "N/A"}
                        </p>
                      </div>
                      <div className="mb-4">
                        <p className="text-sm font-medium text-gray-500">
                          Project Number
                        </p>
                        <p className="text-gray-800">
                          {projectDetails?.projectNumber || "N/A"}
                        </p>
                      </div>
                      <div className="mb-4">
                        <p className="text-sm font-medium text-gray-500">
                          Status
                        </p>
                        <p className="text-gray-800 capitalize">
                          {projectDetails?.status || "N/A"}
                        </p>
                      </div>
                    </div>
                    <div>
                      <div className="mb-4">
                        <p className="text-sm font-medium text-gray-500">
                          Contact Person
                        </p>
                        <p className="text-gray-800">
                          {projectDetails?.projectDetails
                            ?.project_contact_person || "N/A"}
                        </p>
                      </div>
                      <div className="mb-4">
                        <p className="text-sm font-medium text-gray-500">
                          Email
                        </p>
                        <p className="text-gray-800">
                          {projectDetails?.projectDetails?.project_email ||
                            "N/A"}
                        </p>
                      </div>
                      <div className="mb-4">
                        <p className="text-sm font-medium text-gray-500">
                          Phone
                        </p>
                        <p className="text-gray-800">
                          {projectDetails?.projectDetails
                            ?.project_phone_number || "N/A"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Project Forms */}
                <div className="bg-white rounded-lg shadow-md p-6">
                  <h2 className="text-lg font-semibold text-gray-800 mb-4">
                    Project Forms
                  </h2>
                  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
                    <Link
                      to={`/approval-listing-page/${projectId}`}
                      className="flex flex-col items-center justify-center p-4 border rounded-lg hover:bg-gray-50 transition-colors"
                    >
                      <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-full mb-3">
                        <img
                          src="/approval_form.svg"
                          alt=""
                          className="w-6 h-6"
                        />
                      </div>
                      <p className="text-sm font-medium text-center">
                        Scaffold Form
                      </p>
                    </Link>
                    <Link
                      to={`/observation-listing/${projectId}`}
                      className="flex flex-col items-center justify-center p-4 border rounded-lg hover:bg-gray-50 transition-colors"
                    >
                      <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-full mb-3">
                        <img
                          src="/after_control.svg"
                          alt=""
                          className="w-6 h-6"
                        />
                      </div>
                      <p className="text-sm font-medium text-center">
                        Observation
                      </p>
                    </Link>
                    <Link
                      to={`/material-listing-page/${projectId}`}
                      className="flex flex-col items-center justify-center p-4 border rounded-lg hover:bg-gray-50 transition-colors"
                    >
                      <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-full mb-3">
                        <img
                          src="/material_list.svg"
                          alt=""
                          className="w-6 h-6"
                        />
                      </div>
                      <p className="text-sm font-medium text-center">
                        Material List
                      </p>
                    </Link>
                    <Link
                      to={`/files/${projectId}`}
                      className="flex flex-col items-center justify-center p-4 border rounded-lg hover:bg-gray-50 transition-colors"
                    >
                      <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-full mb-3">
                        <img src="/files.svg" alt="" className="w-6 h-6" />
                      </div>
                      <p className="text-sm font-medium text-center">Files</p>
                    </Link>
                    <Link
                      to={`/pictures/${projectId}`}
                      className="flex flex-col items-center justify-center p-4 border rounded-lg hover:bg-gray-50 transition-colors"
                    >
                      <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-full mb-3">
                        <img src="/pictures_1.svg" alt="" className="w-6 h-6" />
                      </div>
                      <p className="text-sm font-medium text-center">
                        Pictures
                      </p>
                    </Link>
                    <Link
                      to={`/safe-job-analysis-listing/${projectId}`}
                      className="flex flex-col items-center justify-center p-4 border rounded-lg hover:bg-gray-50 transition-colors"
                    >
                      <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-full mb-3">
                        <img
                          src="/approval_form.svg"
                          alt=""
                          className="w-6 h-6"
                        />
                      </div>
                      <p className="text-sm font-medium text-center">
                        Safe Job Analysis
                      </p>
                    </Link>
                  </div>
                </div>

                {/* Key Metrics */}
                <div className="bg-white rounded-lg shadow-md p-6">
                  <h2 className="text-lg font-semibold text-gray-800 mb-4">
                    Key Metrics
                  </h2>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    <div className="p-4 border rounded-lg">
                      <p className="text-sm font-medium text-gray-500 mb-1">
                        Active Scaffolds
                      </p>
                      <p className="text-xl font-bold text-gray-800">
                        {activeScaffolds ? activeScaffolds.length : <Loader />}
                      </p>
                    </div>
                    <div className="p-4 border rounded-lg">
                      <p className="text-sm font-medium text-gray-500 mb-1">
                        Scaffolding Items
                      </p>
                      <p className="text-xl font-bold text-gray-800">
                        {scaffoldingWeightLoading ? (
                          <Loader />
                        ) : (
                          scaffoldingItems
                        )}
                      </p>
                    </div>
                    <div className="p-4 border rounded-lg">
                      <p className="text-sm font-medium text-gray-500 mb-1">
                        Observations
                      </p>
                      <p className="text-xl font-bold text-gray-800">
                        {onservationIsLoading ? <Loader /> : observationCount}
                      </p>
                    </div>
                    <div className="p-4 border rounded-lg">
                      <p className="text-sm font-medium text-gray-500 mb-1">
                        Work Tasks
                      </p>
                      <p className="text-xl font-bold text-gray-800">
                        {sjaIsLoading ? <Loader /> : sja}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Team Members */}
                {filterProject && filterProject.length > 0 && (
                  <div className="bg-white rounded-lg shadow-md p-6">
                    <h2 className="text-lg font-semibold text-gray-800 mb-4">
                      Team Members
                    </h2>
                    <div className="overflow-x-auto">
                      <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                          <tr>
                            <th
                              scope="col"
                              className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                            >
                              Email
                            </th>
                            <th
                              scope="col"
                              className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                            >
                              Position
                            </th>
                          </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                          {filterProject.map((member, index) => (
                            <tr key={index}>
                              <td className="px-6 py-4 whitespace-nowrap">
                                <div className="flex items-center">
                                  <div className="flex-shrink-0 h-10 w-10">
                                    {member?.type === 0 ? (
                                      <img
                                        className="h-10 w-10 rounded-full"
                                        src="https://res.cloudinary.com/ddrvpin2u/image/upload/v1713519226/salus_project/cw1vt2tos072kph5pcz5.jpg"
                                        alt=""
                                      />
                                    ) : member?.type === 1 ? (
                                      <img
                                        className="h-10 w-10 rounded-full"
                                        src="https://res.cloudinary.com/ddrvpin2u/image/upload/v1713519226/salus_project/cw1vt2tos072kph5pcz5.jpg"
                                        alt=""
                                      />
                                    ) : (
                                      <img
                                        className="h-10 w-10 rounded-full"
                                        src="https://res.cloudinary.com/ddrvpin2u/image/upload/v1713519028/salus_project/u1vio21atnss7iksikkm.png"
                                        alt=""
                                      />
                                    )}
                                  </div>
                                  <div className="ml-4">
                                    <div className="text-sm font-medium text-gray-900">
                                      {member.email}
                                    </div>
                                  </div>
                                </div>
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap">
                                <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                                  {member?.type === 0
                                    ? "Admin"
                                    : member?.type === 1
                                    ? "User"
                                    : "Guest"}
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </div>
            )}

            {activeTab === "company" && (
              <div className="bg-white rounded-lg shadow-md p-6">
                <h2 className="text-lg font-semibold text-gray-800 mb-6">
                  Company Details
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="space-y-4">
                    <div>
                      <p className="text-sm font-medium text-gray-500">
                        Company Name
                      </p>
                      <p className="text-gray-800 border p-3 rounded-md bg-gray-50 mt-1">
                        {projectDetails?.companyDetails?.company_name || "N/A"}
                      </p>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-gray-500">
                        Organization Number
                      </p>
                      <p className="text-gray-800 border p-3 rounded-md bg-gray-50 mt-1">
                        {projectDetails?.companyDetails
                          ?.company_organization_number || "N/A"}
                      </p>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-gray-500">
                        Invoice Address
                      </p>
                      <p className="text-gray-800 border p-3 rounded-md bg-gray-50 mt-1">
                        {projectDetails?.companyDetails
                          ?.comapny_invoice_address || "N/A"}
                      </p>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-gray-500">
                        Contact Person
                      </p>
                      <p className="text-gray-800 border p-3 rounded-md bg-gray-50 mt-1">
                        {projectDetails?.companyDetails
                          ?.company_contact_person || "N/A"}
                      </p>
                    </div>
                  </div>
                  <div className="space-y-4">
                    <div>
                      <p className="text-sm font-medium text-gray-500">Email</p>
                      <p className="text-gray-800 border p-3 rounded-md bg-gray-50 mt-1">
                        {projectDetails?.companyDetails?.company_email || "N/A"}
                      </p>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-gray-500">
                        Phone Number
                      </p>
                      <p className="text-gray-800 border p-3 rounded-md bg-gray-50 mt-1">
                        {projectDetails?.companyDetails?.company_phone_number ||
                          "N/A"}
                      </p>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-gray-500">
                        Other Company Details
                      </p>
                      <p className="text-gray-800 border p-3 rounded-md bg-gray-50 mt-1 h-24 overflow-y-auto">
                        {projectDetails?.companyDetails
                          ?.other_company_details || "N/A"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "project" && (
              <div className="bg-white rounded-lg shadow-md p-6">
                <h2 className="text-lg font-semibold text-gray-800 mb-6">
                  Project Details
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="space-y-4">
                    <div>
                      <p className="text-sm font-medium text-gray-500">
                        Contact Person
                      </p>
                      <p className="text-gray-800 border p-3 rounded-md bg-gray-50 mt-1">
                        {projectDetails?.projectDetails
                          ?.project_contact_person || "N/A"}
                      </p>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-gray-500">
                        Phone Number
                      </p>
                      <p className="text-gray-800 border p-3 rounded-md bg-gray-50 mt-1">
                        {projectDetails?.projectDetails?.project_phone_number ||
                          "N/A"}
                      </p>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-gray-500">Email</p>
                      <p className="text-gray-800 border p-3 rounded-md bg-gray-50 mt-1">
                        {projectDetails?.projectDetails?.project_email || "N/A"}
                      </p>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-gray-500">
                        Address
                      </p>
                      <p className="text-gray-800 border p-3 rounded-md bg-gray-50 mt-1">
                        {projectDetails?.projectDetails?.project_address ||
                          "N/A"}
                      </p>
                    </div>
                  </div>
                  <div className="space-y-4">
                    <div>
                      <p className="text-sm font-medium text-gray-500">
                        Other Project Details
                      </p>
                      <p className="text-gray-800 border p-3 rounded-md bg-gray-50 mt-1 h-24 overflow-y-auto">
                        {projectDetails?.projectDetails
                          ?.other_project_details || "N/A"}
                      </p>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-gray-500">
                        Project Status
                      </p>
                      <p
                        className={`inline-block px-3 py-1 text-sm font-medium text-white rounded-full mt-1 ${getStatusColor(
                          projectDetails?.status
                        )}`}
                      >
                        {projectDetails?.status || "N/A"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "metrics" && (
              <div className="space-y-6">
                {/* Measurements */}
                <div className="bg-white rounded-lg shadow-md p-6">
                  <h2 className="text-lg font-semibold text-gray-800 mb-4">
                    Scaffold Measurements
                  </h2>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    <div className="p-4 border rounded-lg">
                      <p className="text-sm font-medium text-gray-500 mb-1">
                        Square Meters (m²)
                      </p>
                      <p className="text-xl font-bold text-gray-800">{m2}</p>
                    </div>
                    <div className="p-4 border rounded-lg">
                      <p className="text-sm font-medium text-gray-500 mb-1">
                        Cubic Meters (m³)
                      </p>
                      <p className="text-xl font-bold text-gray-800">
                        {isNaN(m3) || m3 == null ? 0 : m3}
                      </p>
                    </div>
                    <div className="p-4 border rounded-lg">
                      <p className="text-sm font-medium text-gray-500 mb-1">
                        Length Meters (lm)
                      </p>
                      <p className="text-xl font-bold text-gray-800">{lm}</p>
                    </div>
                    <div className="p-4 border rounded-lg">
                      <p className="text-sm font-medium text-gray-500 mb-1">
                        Height Meters (hm)
                      </p>
                      <p className="text-xl font-bold text-gray-800">{hm}</p>
                    </div>
                  </div>
                </div>

                {/* Project Metrics */}
                <div className="bg-white rounded-lg shadow-md p-6">
                  <h2 className="text-lg font-semibold text-gray-800 mb-4">
                    Project Metrics
                  </h2>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
                    <div className="p-4 border rounded-lg">
                      <p className="text-sm font-medium text-gray-500 mb-1">
                        Active Scaffolds
                      </p>
                      <p className="text-xl font-bold text-blue-600">
                        {activeScaffolds ? activeScaffolds.length : <Loader />}
                      </p>
                    </div>
                    <div className="p-4 border rounded-lg">
                      <p className="text-sm font-medium text-gray-500 mb-1">
                        Scaffolding Items
                      </p>
                      <p className="text-xl font-bold text-blue-600">
                        {scaffoldingWeightLoading ? (
                          <Loader />
                        ) : (
                          scaffoldingItems
                        )}
                      </p>
                    </div>
                    <div className="p-4 border rounded-lg">
                      <p className="text-sm font-medium text-gray-500 mb-1">
                        Scaffolding Weight
                      </p>
                      <div>
                        <p className="text-xl font-bold text-blue-600">
                          {scaffoldingWeightLoading ? (
                            <Loader />
                          ) : (
                            <>{materialWeight} Kgs</>
                          )}
                        </p>
                        {indicator !== undefined && indicator !== 0 && (
                          <span
                            className={
                              indicator < 0
                                ? "text-red-500 flex items-center text-sm"
                                : "text-green-500 flex items-center text-sm"
                            }
                          >
                            {indicator < 0 ? (
                              <FaArrowDown className="mr-1" />
                            ) : (
                              <FaArrowUp className="mr-1" />
                            )}
                            {indicator} Kgs
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="p-4 border rounded-lg">
                      <p className="text-sm font-medium text-gray-500 mb-1">
                        Observations
                      </p>
                      <p className="text-xl font-bold text-blue-600">
                        {onservationIsLoading ? <Loader /> : observationCount}
                      </p>
                    </div>
                    <div className="p-4 border rounded-lg">
                      <p className="text-sm font-medium text-gray-500 mb-1">
                        Work Tasks
                      </p>
                      <p className="text-xl font-bold text-blue-600">
                        {sjaIsLoading ? <Loader /> : sja}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Active Scaffolds */}
                {activeScaffolds && activeScaffolds.length > 0 && (
                  <div className="bg-white rounded-lg shadow-md p-6">
                    <h2 className="text-lg font-semibold text-gray-800 mb-4">
                      Active Scaffolds
                    </h2>
                    <div className="overflow-x-auto">
                      <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                          <tr>
                            <th
                              scope="col"
                              className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                            >
                              Name
                            </th>
                            <th
                              scope="col"
                              className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                            >
                              Type
                            </th>
                            <th
                              scope="col"
                              className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                            >
                              Status
                            </th>
                          </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                          {activeScaffolds.map((scaffold, index) => (
                            <tr key={index}>
                              <td className="px-6 py-4 whitespace-nowrap">
                                <div className="text-sm font-medium text-gray-900">
                                  {scaffold.scaffoldName &&
                                  scaffold.scaffoldName[0]
                                    ? scaffold.scaffoldName[0].name
                                    : "N/A"}
                                </div>
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap">
                                <div className="text-sm text-gray-500">
                                  {scaffold.scaffoldName &&
                                  scaffold.scaffoldName[0]
                                    ? scaffold.scaffoldName[0].type
                                    : "N/A"}
                                </div>
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap">
                                <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                                  {scaffold.status}
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}
    </MainLayout>
  );
};

export default ProjectView;
